(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-facets-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__facetsDrawerLiveFilter) return;
    window.__facetsDrawerLiveFilter = true;

    const isLiveFilterEvent = (event) => {
      if (event.type === 'submit' && event.submitter) return false;
      const drawer = event.target?.closest?.('facets-drawer') || document.querySelector('facets-drawer[open]');
      return Boolean(drawer?.querySelector('facets-form[update-on-change]'));
    };

    const getLiveDrawerHost = () =>
      document.getElementById('collection')?.closest('.shopify-section') ||
      document.querySelector('main .shopify-section') ||
      document.querySelector('main');

    const restoreDrawerHost = (drawer) => {
      if (!drawer || drawer.isConnected) return;
      const existing = document.getElementById(drawer.id);
      if (existing && existing !== drawer) return;
      const host = getLiveDrawerHost();
      if (host) host.appendChild(drawer);
    };

    const patchDrawerHide = () => {
      const Ctor = customElements.get('facets-drawer');
      if (!Ctor || Ctor.prototype.__keepOpenPatched) return;

      const originalHide = Ctor.prototype.hide;
      Ctor.prototype.__keepOpenPatched = true;
      Ctor.prototype.hide = function (...args) {
        if (window.__keepFacetsDrawerOpen) return Promise.resolve();
        return Promise.resolve(originalHide.apply(this, args)).finally(() => {
          restoreDrawerHost(this);
        });
      };

      document.querySelectorAll('facets-drawer').forEach((drawer) => {
        drawer.removeEventListener('submit', originalHide);
        drawer.removeEventListener('reset', originalHide);
        drawer.removeEventListener('facet:update', originalHide);
        drawer.addEventListener('submit', drawer.hide);
        drawer.addEventListener('reset', drawer.hide);
        drawer.addEventListener('facet:update', drawer.hide);
      });
    };

    customElements.whenDefined('facets-drawer').then(patchDrawerHide);
    if (customElements.get('facets-drawer')) patchDrawerHide();

    const bindFormStopHide = () => {
      document.querySelectorAll('facets-form[update-on-change] form').forEach((form) => {
        if (form.__stopHideBound) return;
        form.__stopHideBound = true;
        form.addEventListener('submit', (event) => {
          if (!event.submitter) event.stopPropagation();
        });
      });
    };

    bindFormStopHide();

    /* 去重：同组选项共用一个 param_name，重复计入会让 key 随可选项数量变化 */
    const getDetailsKey = (details) => {
      const names = new Set(
        Array.from(details.querySelectorAll('input[name]'), (input) => input.name).filter(
          (name) => name === 'sort_by' || name.includes('filter.')
        )
      );
      return Array.from(names).sort().join('|');
    };

    const saveOpenDetails = (drawer) => {
      window.__openFacetDetails = new Set(
        Array.from(drawer.querySelectorAll('details[open]'), getDetailsKey).filter(Boolean)
      );
    };

    const restoreOpenDetails = (drawer) => {
      const openKeys = window.__openFacetDetails;
      if (!openKeys || openKeys.size === 0) return;
      drawer.querySelectorAll('details').forEach((details) => {
        const key = getDetailsKey(details);
        if (!key) return;
        details.toggleAttribute('open', openKeys.has(key));
        details.closest('accordion-disclosure')?.classList.toggle('is-open', details.open);
      });
    };

    const markKeepOpen = (event) => {
      if (!isLiveFilterEvent(event)) return;
      const drawer = event.target?.closest?.('facets-drawer') || document.querySelector('facets-drawer[open]');
      if (drawer) {
        window.__facetsDrawerScrollTop = drawer.getShadowPartByName?.('body')?.scrollTop || 0;
        saveOpenDetails(drawer);
      }
      window.__keepFacetsDrawerOpen = true;
    };

    document.addEventListener('submit', markKeepOpen, true);
    document.addEventListener('facet:update', markKeepOpen, true);
    document.addEventListener('dialog:after-hide', (event) => {
      if (event.target?.matches?.('facets-drawer')) restoreDrawerHost(event.target);
    });

    const syncOpenDrawer = () => {
      if (!window.__keepFacetsDrawerOpen) return;
      window.__keepFacetsDrawerOpen = false;

      const drawers = Array.from(document.querySelectorAll('facets-drawer'));
      const openDrawer = drawers.find((drawer) => drawer.open);
      const incoming = drawers.find((drawer) => drawer !== openDrawer);

      if (!incoming) return;

      restoreOpenDetails(incoming);
      bindFormStopHide();

      const scrollTop = window.__facetsDrawerScrollTop || 0;
      if (openDrawer && openDrawer !== incoming) openDrawer.remove();

      incoming.show({ animate: false }).then(() => {
        const body = incoming.getShadowPartByName?.('body');
        if (body) body.scrollTop = scrollTop;
      });
    };

    document.documentElement.addEventListener('theme:loading:end', () => {
      requestAnimationFrame(() => requestAnimationFrame(syncOpenDrawer));
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-toolbar"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('collection-sticky-bar')) return;

    class CollectionStickyBar extends HTMLElement {
      connectedCallback() {
        this.ticking = false;
        this.onScroll = () => {
          if (this.ticking) return;
          this.ticking = true;
          requestAnimationFrame(() => {
            this.sync();
            this.ticking = false;
          });
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.sync();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        this.classList.remove('is-fixed');
        this.syncHeaderHover();
      }

      sync() {
        const top = this.getBoundingClientRect().top;
        const isFixed = this.classList.contains('is-fixed') ? top <= 0 : top < 0 && window.scrollY > 0;

        if (isFixed) {
          if (!this.classList.contains('is-fixed')) {
            this.style.height = `${this.offsetHeight}px`;
            this.classList.add('is-fixed');
          }
        } else {
          this.classList.remove('is-fixed');
          this.style.height = '';
        }

        this.syncHeaderHover();
      }

      // 吸顶期间关掉 header 的鼠标靠顶唤出，避免 header 弹出把吸顶条往下推
      syncHeaderHover() {
        document.documentElement.classList.toggle(
          'header-hover-disabled',
          document.querySelector('collection-sticky-bar.is-fixed') !== null
        );
      }
    }

    customElements.define('collection-sticky-bar', CollectionStickyBar);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["promotion-material-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    const root = document.querySelector("[data-mt-materials]");
    if (!root || root.hasAttribute("data-mt-drawer-bound")) return;
    root.setAttribute("data-mt-drawer-bound", "");

    const dialogs = Array.from(root.querySelectorAll("[data-mt-drawer]"));
    const rootEl = document.documentElement;
    let lastFocus = null;

    const lockPage = () => {
      if (rootEl.classList.contains("is-mt-drawer-open")) return;
      if (!rootEl.style.getPropertyValue("--scrollbar-width")) {
        rootEl.style.setProperty("--scrollbar-width", `${window.innerWidth - rootEl.clientWidth}px`);
      }
      rootEl.classList.add("is-mt-drawer-open");
    };

    const unlockPage = () => {
      rootEl.classList.remove("is-mt-drawer-open");
      if (!rootEl.classList.contains("lock")) {
        rootEl.style.removeProperty("--scrollbar-width");
      }
    };

    const closeDrawer = (dialog) => {
      if (!dialog || !dialog.classList.contains("is-visible")) return;
      dialog.classList.remove("is-open");
      window.setTimeout(() => {
        dialog.classList.remove("is-visible");
        dialog.hidden = true;
        if (!root.querySelector("[data-mt-drawer].is-visible")) {
          unlockPage();
        }
        if (lastFocus) lastFocus.focus();
      }, 360);
    };

    const openDrawer = (id, trigger) => {
      const dialog = root.querySelector(`[data-mt-drawer="${id}"]`);
      if (!dialog) return;
      lastFocus = trigger || document.activeElement;
      dialog.hidden = false;
      dialog.classList.add("is-visible");
      lockPage();
      requestAnimationFrame(() => dialog.classList.add("is-open"));
      const closeBtn = dialog.querySelector(".mt-drawer__close");
      if (closeBtn) closeBtn.focus();
    };

    root.querySelectorAll("[data-mt-drawer-open]").forEach((button) => {
      button.addEventListener("click", () => {
        openDrawer(button.getAttribute("data-mt-drawer-open"), button);
      });
    });

    root.querySelectorAll("[data-mt-drawer-close]").forEach((el) => {
      el.addEventListener("click", () => {
        closeDrawer(el.closest("[data-mt-drawer]"));
      });
    });

    document.addEventListener("click", (event) => {
      const openDialog = root.querySelector("[data-mt-drawer].is-open");
      if (!openDialog) return;
      if (event.target.closest("[data-mt-drawer-open]")) return;
      if (event.target.closest(".mt-drawer__panel")) return;
      closeDrawer(openDialog);
    });

    document.addEventListener("keydown", (event) => {
      if (event.key !== "Escape") return;
      dialogs.forEach((dialog) => closeDrawer(dialog));
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["promotion-subnav"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__ffSubnavBound) return;
    window.__ffSubnavBound = true;

    const rootOf = (el) => (el && el.closest ? el.closest('[data-ff-subnav]') : null);

    const sectionOf = (root, id) => {
      if (!root || !id) return null;
      const scope = root.closest('[data-ff-page-panel]') || root.closest('[data-ff-page-tabs]') || document;
      const section = scope.querySelector(`[data-ff-subnav-section="${CSS.escape(id)}"]`) || document.getElementById(id);
      if (!section) return null;
      const panel = section.closest('[data-ff-page-panel]');
      if (panel && panel.hidden) return null;
      return section;
    };

    const syncPinnedHeight = () => {
      const bar = document.querySelector('[data-ff-page-tabs-bar].is-pinned');
      const height = bar ? bar.offsetHeight : 0;
      document.documentElement.style.setProperty('--ff-page-tabs-pinned-height', `${height}px`);
      return height;
    };

    const isDropdownNav = () => window.matchMedia('(max-width: 999px)').matches;

    const announcementOffset = () => {
      const styles = getComputedStyle(document.documentElement);
      const sticky = parseFloat(styles.getPropertyValue('--announcement-bar-is-sticky')) || 0;
      const height = parseFloat(styles.getPropertyValue('--announcement-bar-height')) || 0;
      return sticky * height;
    };

    const pinnedTabsBar = () => document.querySelector('[data-ff-page-tabs-bar].is-pinned');

    const syncSubnavPinnedHeight = () => {
      const host = document.querySelector('[data-ff-subnav].is-pinned:not(.is-concealed)');
      document.documentElement.style.setProperty(
        '--ff-subnav-pinned-height',
        `${host ? host.offsetHeight : 0}px`
      );
    };

    const unpinHost = (root) => {
      if (!root) return;
      root.classList.remove('is-pinned', 'is-concealed');
      const slot = root.closest('[data-ff-subnav-slot]');
      if (slot) slot.style.height = '';
      syncSubnavPinnedHeight();
    };

    const syncConceal = (root) => {
      if (!root) return;
      const bar = pinnedTabsBar();
      const hide = Boolean(bar && bar.classList.contains('is-concealed'));
      root.classList.toggle('is-concealed', hide);
      if (hide) closeMenu(root);
      syncSubnavPinnedHeight();
    };

    const pinHost = (root) => {
      if (!root) return;
      if (!root.classList.contains('is-pinned')) {
        const slot = root.closest('[data-ff-subnav-slot]');
        if (slot) slot.style.height = `${root.offsetHeight}px`;
        root.classList.add('is-pinned');
      }
      syncConceal(root);
    };

    const shouldPinHost = (root) => {
      if (!root || !isDropdownNav()) return false;
      const panel = root.closest('[data-ff-page-panel]');
      if (panel && panel.hidden) return false;
      const bar = pinnedTabsBar();
      if (!bar) return false;
      const slot = root.closest('[data-ff-subnav-slot]') || root;
      return slot.getBoundingClientRect().top <= announcementOffset() + bar.offsetHeight + 0.5;
    };

    const syncHostPin = () => {
      syncPinnedHeight();
      document.querySelectorAll('[data-ff-subnav]').forEach((root) => {
        if (shouldPinHost(root)) pinHost(root);
        else if (!holdSpy) unpinHost(root);
      });
    };

    let holdSpy = false;
    let holdSpyDone = null;
    let pinFill = false;
    let pinScrollY = null;
    const lineTweens = new WeakMap();

    const landExtra = () => (window.matchMedia('(max-width: 999px)').matches ? 16 : 24);

    const releasePinFill = () => {
      if (!pinFill || pinScrollY == null) return;
      if (Math.abs(window.scrollY - pinScrollY) > 8) {
        pinFill = false;
        pinScrollY = null;
      }
    };

    const moveFill = (root, fill, to, animate) => {
      const running = lineTweens.get(root);
      if (running && Math.abs(running.to - to) < 12) return;
      if (running) cancelAnimationFrame(running.id);

      const from = Number.parseFloat(fill.getAttribute('y2') || '0') || 0;
      if (!animate || Math.abs(to - from) < 0.5) {
        lineTweens.delete(root);
        fill.setAttribute('y2', String(to));
        return;
      }

      const duration = Math.min(640, Math.max(360, Math.abs(to - from) * 10));
      const started = performance.now();
      const easeOut = (t) => 1 - (1 - t) ** 3;
      const state = { to, id: 0 };
      const step = (now) => {
        const t = Math.min(1, (now - started) / duration);
        fill.setAttribute('y2', String(from + (to - from) * easeOut(t)));
        if (t < 1) {
          state.id = requestAnimationFrame(step);
        } else {
          lineTweens.delete(root);
        }
      };

      state.id = requestAnimationFrame(step);
      lineTweens.set(root, state);
    };

    const holdSpyUntilIdle = () => {
      holdSpy = true;
      if (holdSpyDone) {
        window.removeEventListener('scrollend', holdSpyDone);
        clearTimeout(holdSpyDone.timer);
        clearInterval(holdSpyDone.poll);
      }
      let settled = false;
      let last = window.scrollY;
      let still = 0;
      const finish = () => {
        if (settled) return;
        settled = true;
        window.removeEventListener('scrollend', finish);
        clearInterval(poll);
        clearTimeout(limit);
        holdSpyDone = null;
        holdSpy = false;
        pinFill = true;
        pinScrollY = window.scrollY;
        syncHostPin();
        syncSpy();
      };
      const poll = setInterval(() => {
        const y = window.scrollY;
        if (Math.abs(y - last) < 1) {
          still += 1;
          if (still >= 4) finish();
        } else {
          still = 0;
          last = y;
        }
      }, 50);
      const limit = setTimeout(finish, 2500);
      finish.timer = limit;
      finish.poll = poll;
      holdSpyDone = finish;
      window.addEventListener('scrollend', finish, { once: true });
    };

    const pinOffset = (root) => {
      let top = syncPinnedHeight();
      const host = root || document.querySelector('[data-ff-subnav]');
      if (host && isDropdownNav() && !host.classList.contains('is-concealed')) {
        const flow = getComputedStyle(host).position;
        if (flow === 'sticky' || flow === 'fixed') {
          top += host.getBoundingClientRect().height;
        }
      }
      return top;
    };

    const setCurrent = (root, id, animate) => {
      if (!root || !id) return;
      const links = Array.from(root.querySelectorAll('[data-ff-subnav-link]'));
      let label = '';

      links.forEach((link) => {
        const on = link.getAttribute('data-ff-subnav-link') === id;
        link.classList.toggle('is-active', on);
        if (link.classList.contains('ff-subnav__link')) {
          if (on) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        }
        if (link.classList.contains('ff-subnav__option')) {
          if (on) link.setAttribute('aria-selected', 'true');
          else link.removeAttribute('aria-selected');
        }
        if (on) {
          const labelNode = link.querySelector('.ff-subnav__label, .ff-subnav__option-label');
          label = ((labelNode && labelNode.textContent) || '').trim();
        }
      });

      const current = root.querySelector('[data-ff-subnav-current]');
      if (current && label) current.textContent = label;
      paintLine(root, animate);
    };

    const paintLine = (root, animate) => {
      const list = root.querySelector('.ff-subnav__list');
      const progress = root.querySelector('.ff-subnav__progress');
      const svg = root.querySelector('[data-ff-subnav-svg]');
      const track = root.querySelector('[data-ff-subnav-track]');
      const fill = root.querySelector('[data-ff-subnav-fill]');
      if (!list || !progress || !svg || !track || !fill) return;

      if (window.matchMedia('(max-width: 999px)').matches) {
        fill.setAttribute('y2', '0');
        return;
      }

      const items = Array.from(root.querySelectorAll('.ff-subnav__item'));
      const dots = items.map((item) => item.querySelector('.ff-subnav__dot')).filter(Boolean);
      if (!dots.length) return;

      const listRect = list.getBoundingClientRect();
      const axis = items[0].querySelector('.ff-subnav__axis');
      if (axis) {
        progress.style.left = `${axis.getBoundingClientRect().left - listRect.left}px`;
      }

      const first = dots[0].getBoundingClientRect();
      const last = dots[dots.length - 1].getBoundingClientRect();
      const start = first.top + first.height / 2 - listRect.top;
      const end = last.top + last.height / 2 - listRect.top;
      const height = Math.max(listRect.height, end);
      svg.setAttribute('viewBox', `0 0 4 ${height}`);
      svg.setAttribute('height', String(height));
      track.setAttribute('y1', String(start));
      track.setAttribute('y2', String(end));
      fill.setAttribute('y1', String(start));

      const ids = items
        .map((item) => {
          const link = item.querySelector('.ff-subnav__link[data-ff-subnav-link]');
          return link ? link.getAttribute('data-ff-subnav-link') : '';
        })
        .filter(Boolean);
      const marker = pinOffset(root) + landExtra();
      const stops = ids.map((id, index) => {
        const section = sectionOf(root, id);
        const dot = dots[index].getBoundingClientRect();
        return {
          center: dot.top + dot.height / 2 - listRect.top,
          sectionTop: section ? section.getBoundingClientRect().top : Infinity,
        };
      });

      const active = root.querySelector('.ff-subnav__link.is-active');
      const activeId = active && active.getAttribute('data-ff-subnav-link');
      const activeIndex = ids.indexOf(activeId);
      let fillEnd = activeIndex >= 0 ? stops[activeIndex].center : start;
      if (!holdSpy && !pinFill && stops.length && stops[0].sectionTop <= marker) {
        let index = 0;
        while (index < stops.length - 1 && stops[index + 1].sectionTop <= marker) {
          index += 1;
        }
        if (index >= stops.length - 1) {
          fillEnd = end;
        } else {
          const range = stops[index + 1].sectionTop - stops[index].sectionTop;
          const t = range <= 0 ? 1 : Math.min(1, Math.max(0, (marker - stops[index].sectionTop) / range));
          fillEnd = stops[index].center + (stops[index + 1].center - stops[index].center) * t;
        }
      }

      const lineEnd = Math.min(end, Math.max(start, fillEnd));
      items.forEach((item, index) => {
        const reached = Boolean(stops[index] && lineEnd + 0.5 >= stops[index].center);
        item.classList.toggle('is-done', reached);
      });
      moveFill(root, fill, lineEnd, Boolean(animate));
    };

    const closeMenu = (root) => {
      if (!root) return;
      root.classList.remove('is-open');
      const trigger = root.querySelector('[data-ff-subnav-trigger]');
      const menu = root.querySelector('[data-ff-subnav-menu]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (menu) menu.hidden = true;
    };

    const openMenu = (root) => {
      if (!root) return;
      root.classList.add('is-open');
      const trigger = root.querySelector('[data-ff-subnav-trigger]');
      const menu = root.querySelector('[data-ff-subnav-menu]');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      if (menu) menu.hidden = false;
    };

    const scrollToId = (root, id) => {
      const target = sectionOf(root, id);
      if (!target) return;
      pinFill = true;
      pinScrollY = null;
      holdSpyUntilIdle();
      document.dispatchEvent(new CustomEvent('ff-page-tabs:programmatic-scroll'));
      if (isDropdownNav()) pinHost(root);
      const extra = landExtra();
      const top = window.scrollY + target.getBoundingClientRect().top - pinOffset(root) - extra;
      window.scrollTo({ top: Math.max(0, top), left: 0, behavior: 'smooth' });
      setCurrent(root, id, true);
      closeMenu(root);
    };

    const syncSpy = () => {
      if (holdSpy) return;
      releasePinFill();
      if (pinFill) {
        document.querySelectorAll('[data-ff-subnav]').forEach((root) => paintLine(root));
        return;
      }
      document.querySelectorAll('[data-ff-subnav]').forEach((root) => {
        const links = Array.from(root.querySelectorAll('[data-ff-subnav-link]'));
        const ids = [...new Set(links.map((link) => link.getAttribute('data-ff-subnav-link')).filter(Boolean))];
        if (!ids.length) return;

        const marker = pinOffset(root) + landExtra();
        let current = ids[0];
        ids.forEach((id) => {
          const section = sectionOf(root, id);
          if (!section) return;
          if (section.getBoundingClientRect().top <= marker) current = id;
        });
        setCurrent(root, current);
      });
    };

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-ff-subnav-trigger]');
      if (trigger) {
        const root = rootOf(trigger);
        if (!root) return;
        if (root.classList.contains('is-open')) closeMenu(root);
        else openMenu(root);
        return;
      }

      const link = event.target.closest('[data-ff-subnav-link]');
      if (link) {
        const root = rootOf(link);
        const id = link.getAttribute('data-ff-subnav-link');
        if (root && id && sectionOf(root, id)) {
          event.preventDefault();
          scrollToId(root, id);
        }
        return;
      }

      document.querySelectorAll('[data-ff-subnav].is-open').forEach((root) => {
        if (!root.contains(event.target)) closeMenu(root);
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('[data-ff-subnav].is-open').forEach(closeMenu);
    });

    let spyTicking = false;
    const onScroll = () => {
      if (spyTicking) return;
      spyTicking = true;
      requestAnimationFrame(() => {
        spyTicking = false;
        syncHostPin();
        syncSpy();
      });
    };

    document.addEventListener('ff-subnav:activate', (event) => {
      const id = event.detail && event.detail.id;
      const scope = event.detail && event.detail.root;
      if (!id) return;
      document.querySelectorAll('[data-ff-subnav]').forEach((root) => {
        if (scope && !scope.contains(root)) return;
        if (!root.querySelector(`[data-ff-subnav-link="${CSS.escape(id)}"]`)) return;
        pinFill = true;
        pinScrollY = null;
        holdSpyUntilIdle();
        setCurrent(root, id, true);
      });
    });

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', () => {
      if (!isDropdownNav()) {
        document.querySelectorAll('[data-ff-subnav].is-open').forEach(closeMenu);
        document.querySelectorAll('[data-ff-subnav].is-pinned').forEach(unpinHost);
      }
      onScroll();
    });

    const observeTabsChrome = () => {
      document.querySelectorAll('[data-ff-page-tabs-bar]').forEach((bar) => {
        if (bar.dataset.ffSubnavChromeObserved) return;
        bar.dataset.ffSubnavChromeObserved = 'true';
        new MutationObserver(syncHostPin).observe(bar, { attributes: true, attributeFilter: ['class'] });
      });
    };

    const boot = () => {
      document.querySelectorAll('[data-ff-subnav]').forEach((root) => {
        const active = root.querySelector('.ff-subnav__link.is-active, .ff-subnav__option.is-active');
        const id = active && active.getAttribute('data-ff-subnav-link');
        if (id) setCurrent(root, id);
      });
      observeTabsChrome();
      syncHostPin();
      syncSpy();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["promotion-tabs"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__ffPageTabsBound) return;
    window.__ffPageTabsBound = true;

    const tabIdOf = (tab) => {
      const href = tab.getAttribute('href') || '';
      const hash = href.indexOf('#');
      if (hash !== -1) return href.slice(hash + 1);
      return '';
    };

    const rootOf = (el) => (el && el.closest ? el.closest('[data-ff-page-tabs]') : null);

    const panelOf = (root, id) => {
      if (!root || !id) return null;
      return (
        root.querySelector(`[data-ff-page-panel="${CSS.escape(id)}"]`) ||
        root.querySelector(`#${CSS.escape(id)}`)
      );
    };

    const isMobileTabs = () => window.matchMedia('(max-width: 699px)').matches;

    const scrollTabIntoView = (tab, smooth) => {
      if (!tab || !isMobileTabs()) return;
      const row = tab.closest('.ff-page-tabs__row');
      if (!row) return;

      const bar = tab.closest('.ff-page-tabs');
      const inset =
        parseFloat((bar && getComputedStyle(bar).getPropertyValue('--ff-page-tabs-inset')) || '') ||
        parseFloat((bar && getComputedStyle(bar).getPropertyValue('--ff-page-tabs-bleed')) || '') ||
        20;
      const rowRect = row.getBoundingClientRect();
      const tabRect = tab.getBoundingClientRect();
      const delta = tabRect.left - rowRect.left - inset;
      const maxScroll = Math.max(0, row.scrollWidth - row.clientWidth);
      const next = Math.min(Math.max(0, row.scrollLeft + delta), maxScroll);

      if (Math.abs(row.scrollLeft - next) < 1) return;
      row.scrollTo({ left: next, behavior: smooth ? 'smooth' : 'auto' });
    };

    const syncHeaderHoverLock = () => {
      document.documentElement.classList.toggle(
        'header-hover-disabled',
        Boolean(document.querySelector('.ff-page-tabs.is-pinned:not(.is-concealed)'))
      );
    };

    const syncPinnedHeight = () => {
      const pinned = document.querySelector('[data-ff-page-tabs-bar].is-pinned');
      const height = pinned ? pinned.offsetHeight : 0;
      document.documentElement.style.setProperty('--ff-page-tabs-pinned-height', `${height}px`);
    };

    const hideHeader = () => {
      document.dispatchEvent(new CustomEvent('header:hide'));
    };

    const lockHeaderHidden = (on) => {
      document.documentElement.classList.toggle('header-force-hidden', on);
      if (on) hideHeader();
    };

    const pinBar = (bar) => {
      if (!bar) return;
      if (!bar.classList.contains('is-pinned')) {
        bar.dataset.pinOrigin = String(window.scrollY + bar.getBoundingClientRect().top);
      }
      const slot = bar.closest('[data-ff-page-tabs-slot]');
      const flow = getComputedStyle(bar).position;
      if (slot && flow !== 'absolute' && flow !== 'fixed') {
        slot.style.height = `${bar.offsetHeight}px`;
      }
      bar.classList.add('is-pinned');
      bar.classList.remove('is-concealed');
      hideHeader();
      syncPinnedHeight();
      syncHeaderHoverLock();
    };

    const concealBar = (bar) => {
      if (!bar || !bar.classList.contains('is-pinned')) return;
      bar.classList.add('is-concealed');
      lockHeaderHidden(false);
      syncPinnedHeight();
      syncHeaderHoverLock();
    };

    const revealBar = (bar) => {
      if (!bar || !bar.classList.contains('is-pinned')) return;
      bar.classList.remove('is-concealed');
      hideHeader();
      syncPinnedHeight();
      syncHeaderHoverLock();
    };

    const unpinBar = (bar) => {
      if (!bar) return;
      bar.classList.remove('is-pinned', 'is-concealed');
      delete bar.dataset.pinOrigin;
      delete bar.dataset.ffTabsChrome;
      const slot = bar.closest('[data-ff-page-tabs-slot]');
      if (slot) slot.style.height = '';
      if (!document.querySelector('.ff-page-tabs.is-pinned')) lockHeaderHidden(false);
      syncPinnedHeight();
      syncHeaderHoverLock();
    };

    let ignorePinScroll = false;
    let lastPinScrollY = window.scrollY || 0;
    let pinScrollTicking = false;

    const pinOffset = () => {
      const styles = getComputedStyle(document.documentElement);
      const sticky = parseFloat(styles.getPropertyValue('--announcement-bar-is-sticky')) || 0;
      const height = parseFloat(styles.getPropertyValue('--announcement-bar-height')) || 0;
      return sticky * height;
    };

    const shouldPin = (bar) => {
      const y = window.scrollY || 0;
      const offset = pinOffset();
      const origin = parseFloat(bar.dataset.pinOrigin);
      if (bar.classList.contains('is-pinned') && !Number.isNaN(origin)) {
        return y >= origin - 0.5;
      }
      return y > 0 && bar.getBoundingClientRect().top <= offset + 0.5;
    };

    const syncPin = (delta) => {
      document.querySelectorAll('[data-ff-page-tabs-bar]').forEach((bar) => {
        if (shouldPin(bar)) {
          if (!bar.classList.contains('is-pinned')) {
            pinBar(bar);
            return;
          }
          if (delta > 8) revealBar(bar);
          else if (delta < -8) concealBar(bar);
          return;
        }

        if (bar.classList.contains('is-pinned')) unpinBar(bar);
      });
    };

    const prefersReduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const unlockPinScroll = () => {
      lastPinScrollY = window.scrollY;
      ignorePinScroll = false;
    };

    const waitScrollIdle = (fn) => {
      let settled = false;
      let last = window.scrollY;
      let still = 0;
      const finish = () => {
        if (settled) return;
        settled = true;
        window.removeEventListener('scrollend', finish);
        clearInterval(poll);
        clearTimeout(limit);
        fn();
      };
      const poll = setInterval(() => {
        const y = window.scrollY;
        if (Math.abs(y - last) < 1) {
          still += 1;
          if (still >= 4) finish();
        } else {
          still = 0;
          last = y;
        }
      }, 50);
      const limit = setTimeout(finish, 2500);
      finish.timer = limit;
      finish.poll = poll;
      window.addEventListener('scrollend', finish, { once: true });
      return finish;
    };

    const pinBarToTop = (bar, panel) => {
      if (!bar || !panel) return;
      ignorePinScroll = true;
      bar.dataset.ffTabsChrome = 'tabs';
      lockHeaderHidden(true);
      hideHeader();

      const fromTop = bar.getBoundingClientRect().top;
      const offset = pinOffset();
      pinBar(bar);

      const reduce = prefersReduceMotion();
      const travel = fromTop - offset;
      if (!reduce && Math.abs(travel) > 1) {
        bar.classList.add('is-pinning');
        bar.style.transition = 'none';
        bar.style.transform = `translateY(${travel}px)`;
        void bar.offsetHeight;
        bar.style.transition = '';
        requestAnimationFrame(() => {
          bar.style.transform = '';
        });
        const onEnd = (event) => {
          if (event.propertyName && event.propertyName !== 'transform') return;
          bar.classList.remove('is-pinning');
          bar.style.transform = '';
          bar.removeEventListener('transitionend', onEnd);
        };
        bar.addEventListener('transitionend', onEnd);
      }

      const intro = panel.querySelector('[data-ff-page-intro]');
      const land = intro || panel.querySelector('[data-ff-subnav-section]') || panel;
      let extra = 0;
      if (!intro && land !== panel) {
        extra = window.matchMedia('(max-width: 999px)').matches ? 16 : 24;
        const subnav = panel.querySelector('[data-ff-subnav]');
        if (subnav && window.matchMedia('(max-width: 999px)').matches && !subnav.classList.contains('is-concealed')) {
          const flow = getComputedStyle(subnav).position;
          if (flow === 'sticky' || flow === 'fixed') extra += subnav.getBoundingClientRect().height;
        }
      }
      const top = Math.max(0, window.scrollY + land.getBoundingClientRect().top - bar.offsetHeight - offset - extra);
      const landId = land.getAttribute('data-ff-subnav-section');
      if (landId) {
        document.dispatchEvent(new CustomEvent('ff-subnav:activate', { detail: { id: landId, root: panel } }));
      }
      window.scrollTo({ top, left: 0, behavior: reduce ? 'auto' : 'smooth' });

      const finish = () => {
        const origin = parseFloat(bar.dataset.pinOrigin);
        if (!Number.isNaN(origin)) {
          bar.dataset.pinOrigin = String(Math.min(origin, window.scrollY));
        }
        hideHeader();
        lockHeaderHidden(false);
        unlockPinScroll();
      };

      if (reduce) {
        requestAnimationFrame(finish);
        return;
      }

      waitScrollIdle(finish);
    };

    const onPinScroll = () => {
      if (ignorePinScroll || pinScrollTicking) return;
      pinScrollTicking = true;
      requestAnimationFrame(() => {
        pinScrollTicking = false;
        if (ignorePinScroll) return;

        const y = window.scrollY || 0;
        const delta = y - lastPinScrollY;
        lastPinScrollY = y;
        syncPin(delta);
      });
    };

    window.addEventListener('scroll', onPinScroll, { passive: true });
    let programScrollDone = null;
    document.addEventListener('ff-page-tabs:programmatic-scroll', () => {
      ignorePinScroll = true;
      lockHeaderHidden(true);
      hideHeader();
      const offset = pinOffset();
      const reduce = prefersReduceMotion();
      document.querySelectorAll('[data-ff-page-tabs-bar]').forEach((bar) => {
        bar.dataset.ffTabsChrome = 'tabs';
        const fromTop = bar.getBoundingClientRect().top;
        const already = bar.classList.contains('is-pinned');
        pinBar(bar);
        const travel = fromTop - offset;
        if (already || reduce || Math.abs(travel) <= 1) return;
        bar.classList.add('is-pinning');
        bar.style.transition = 'none';
        bar.style.transform = `translateY(${travel}px)`;
        void bar.offsetHeight;
        bar.style.transition = '';
        requestAnimationFrame(() => {
          bar.style.transform = '';
        });
        const onEnd = (event) => {
          if (event.propertyName && event.propertyName !== 'transform') return;
          bar.classList.remove('is-pinning');
          bar.style.transform = '';
          bar.removeEventListener('transitionend', onEnd);
        };
        bar.addEventListener('transitionend', onEnd);
      });
      if (programScrollDone) {
        window.removeEventListener('scrollend', programScrollDone);
        clearTimeout(programScrollDone.timer);
        clearInterval(programScrollDone.poll);
      }
      programScrollDone = waitScrollIdle(() => {
        programScrollDone = null;
        document.querySelectorAll('[data-ff-page-tabs-bar].is-pinned').forEach((bar) => {
          const origin = parseFloat(bar.dataset.pinOrigin);
          if (!Number.isNaN(origin)) {
            bar.dataset.pinOrigin = String(Math.min(origin, window.scrollY));
          }
        });
        hideHeader();
        lockHeaderHidden(false);
        unlockPinScroll();
      });
    });
    syncPin(0);

    const activate = (root, id, options) => {
      const updateHash = options && options.updateHash;
      const pinToTop = options && options.pinToTop;
      const target = panelOf(root, id);
      if (!target) return false;

      const tabs = Array.from(root.querySelectorAll('[data-ff-page-tab]'));
      const panels = Array.from(root.querySelectorAll('[data-ff-page-panel]'));
      let activeTab = null;

      tabs.forEach((tab) => {
        const on = tabIdOf(tab) === id;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        if (on) {
          activeTab = tab;
          tab.setAttribute('aria-current', 'true');
        } else {
          tab.removeAttribute('aria-current');
        }
      });

      panels.forEach((panel) => {
        const on = panel === target;
        panel.hidden = !on;
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (panel.id) {
          const tab = tabs.find((item) => tabIdOf(item) === panel.id);
          if (tab) panel.setAttribute('aria-labelledby', tab.id);
        }
      });

      scrollTabIntoView(activeTab, Boolean(updateHash || pinToTop));

      if (pinToTop) {
        const bar = root.querySelector('[data-ff-page-tabs-bar]');
        pinBarToTop(bar, target);
      }

      if (updateHash) {
        const next = `#${id}`;
        if (location.hash !== next) history.replaceState(null, '', next);
      }
      return true;
    };

    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-ff-page-tab-open]');
      if (opener) {
        const root = rootOf(opener);
        if (root && activate(root, opener.getAttribute('data-ff-page-tab-open'), { updateHash: true, pinToTop: true })) {
          event.preventDefault();
        }
        return;
      }

      const tab = event.target.closest('[data-ff-page-tab]');
      if (!tab) return;
      const root = rootOf(tab);
      if (!root) return;
      const id = tabIdOf(tab);
      if (!panelOf(root, id)) return;
      event.preventDefault();
      activate(root, id, { updateHash: true, pinToTop: true });
    });

    const fromHash = () => {
      const id = (location.hash || '').replace('#', '');
      document.querySelectorAll('[data-ff-page-tabs]').forEach((root) => {
        if (id && activate(root, id, { pinToTop: true })) return;
        const tabs = Array.from(root.querySelectorAll('[data-ff-page-tab]'));
        const current = tabs.find((item) => item.classList.contains('is-active')) || tabs[0];
        if (current) activate(root, tabIdOf(current), {});
      });
    };

    window.addEventListener('hashchange', fromHash);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fromHash);
    } else {
      fromHash();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
